module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/question-circle-5b64ccbe4ed14748cadecf8d32851546.svg";